import { getToDay } from '@/models/GenerateCondit/Interrelated';
import { getList, addWayBillNo, insert, audit } from "@/services/TemparRoute/Managen"
import { message } from "antd"
import moment from "moment"
import { useAccess } from "@/utils/hooks"
import { getProvinceId } from '@/services/area';

const params = {
  // startTime: moment().subtract(7, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"),
  // endTime: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
  dateRange: [
    moment().subtract(2, "day").startOf("day"),
    moment().endOf("day")
  ],
  isProvince: "-1",
  examineStatus: "-1"
}
//   UNDENFIED(0, "未定义错误"),
//   ALTER_DLOW_INFO_INSERT_FAILURE(900001, "新增流程信息异常"),
//   ALTER_DLOW_INFO_QUERY_FAILURE(900002, "查询流程信息异常"),
//   ALTER_DLOW_INFO_UPDATE_FAILURE(900003, "修改流程信息异常"),
//   ALTER_DLOW_INFO_DELETE_FAILURE(900004, "删除流程信息异常"),
//   REQUEST_ARGUMENTS_BE_NULL(900004, "请求参数不能为空");
const Error = new Map([
  [0, true],
  [900001, true],
  [900002, true],
  [900003, true],
  [900004, true],
])


export default {
  namespace: 'temparroutemanagen',
  state: {
    searchParams: { ...params },
    dataList: [],
    page: 1,
    pageSize: 20,
    total: 0,

    //---------- 编辑页面--------------
    editVisible: false,
    isView: "add",
    editForm: {},// 最新的
    editFormALL: {},// 初始的

    // 调整运单选项卡
    wayBillDataList: [],
    selectKeys: [],
    selectRows: [],

    // 调整车线
    carLineForm: {},

    // 处理过程记录
    processDataList: [],

    tabRef: {},

  },

  effects: {
    *getList(_, { call, put, select }) {
      const { searchParams, page, pageSize } = yield select(({ temparroutemanagen }) => temparroutemanagen)
      const { centerFilter, provinceArea, examineStatus, isProvince, dateRange } = searchParams
      const params: any = {
        page, pageSize,
        applyAllocateName: centerFilter,
        applyProvinceName: provinceArea && provinceArea.name
      }
      const [startTime, endTime,] = dateRange || []
      if (startTime && endTime) {
        params.startTime = moment(startTime).format("YYYY-MM-DD HH:mm:ss")
        params.endTime = moment(endTime).format("YYYY-MM-DD HH:mm:ss")
      }
      if (examineStatus !== "-1") {
        params.examineStatus = examineStatus
      }
      if (isProvince !== "-1") {
        params.isProvince = isProvince
      }
      const { siteTypeCode, siteName } = useAccess()
      const provinceCode = getProvinceId()

      if (["900100", "900200"].includes(`${siteTypeCode}`) && !provinceCode) {
        params.applyAllocateName = siteName
      }

      const data = yield call(getList, { ...params })
      if (data && data.code === 1) {
        const { rows, total } = data.data || {}
        yield put({
          type: "update",
          payload: {
            total: !isNaN(Number(total)) && Number(total) || 0,
            dataList: rows || [],
          }
        })
      }
    },
    *goPage({ payload }, { put }) {
      yield put({ type: "update", payload })
      yield put({ type: "getList" })
    },
    // 添加单号
    *addWayBillNo({ payload, callBack }, { call, put, select }) {
      const { list } = payload
      const { wayBillDataList, editForm } = yield select(({ temparroutemanagen }) => ({
        wayBillDataList: temparroutemanagen.wayBillDataList,
        editForm: temparroutemanagen.editForm,
      }))
      const { changeBeforeOrgcode, changeAfterOrgcode } = editForm

      const objs = {
        "changeBeforeOrgName": changeBeforeOrgcode.name,
        "changeBeforeOrgCode": changeBeforeOrgcode.code,
        "changeAfterOrgName": changeAfterOrgcode.name,
        "changeAfterOrgCode": changeAfterOrgcode.code,
      }
      // 去重
      const reqList = [];
      (list || []).forEach((key) => {
        const fid = (wayBillDataList || []).find(item => item.waybillNumber === key)
        if (!fid) {
          reqList.push(key)
        }
      })
      const resultList = reqList.map((key) => {
        return {
          ...objs,
          waybillNo: key
        }
      })
      const data = yield call(addWayBillNo, resultList)
      if (data && data.code === 1) {
        message.success(data.message || "操作成功")
        const { routeAlterDetailsFlowDos } = data.data || {}
        const list = (routeAlterDetailsFlowDos || []).map((item) => ({ ...item, ids: (new Date().getTime() * Math.round(10)).toString() }))
        yield put({
          type: "update",
          payload: {
            wayBillDataList: wayBillDataList.concat(list || [])
          }
        })
        callBack && callBack()
      } else if (data && Error.get(data.code)) {
        message.warn(data.message)
      }
    },
    *closeEdit(_, { put }) {
      yield put({
        type: "update",
        payload: {
          //---------- 编辑页面--------------
          editVisible: false,
          isView: "add",
          editForm: {},// 最新的
          editFormALL: {},// 初始的

          // 调整运单选项卡
          wayBillDataList: [],
          // 调整车线
          carLineForm: {},
          // 处理过程记录
          processDataList: [],
          tabRef: {},
        }
      })
    },
    *tabRef({ payload }, { select, put }) {
      const { ref, key } = payload;
      const params = yield select(({ temparroutemanagen }) => ({
        tabRef: temparroutemanagen.tabRef,
      }));
      const { tabRef } = params;
      tabRef[key] = ref;
      yield put({
        type: 'update',
        payload: {
          tabRef,
        },
      });
    },
    // 新增
    *insert({ payload }, { call, put }) {
      const data = yield call(insert, payload)
      if (data && data.code === 1) {
        message.success(data.message || "新增成功")
        yield put({
          type: "closeEdit"
        })
        yield put({
          type: "goPage",
          payload: {
            page: 1
          }
        })
      } else if (data && Error.get(data.code)) {
        message.warn(data.message)
      }
    },
    // 审核
    *audit({ payload }, { call, put, select }) {
      const { editFormALL, selectKeys, wayBillDataList } = yield select(({ temparroutemanagen }) => ({
        editFormALL: temparroutemanagen.editFormALL,
        wayBillDataList: temparroutemanagen.wayBillDataList,
        selectKeys: temparroutemanagen.selectKeys,
      }))
      const resultList = wayBillDataList.filter((it) => (selectKeys || []).includes(it.ids)).map((items) => {
        const { ids, ...rest } = items;
        return { ...rest }
      })
      const data = yield call(audit, {
        ...payload,
        ...editFormALL,
        routeAlterDetailsFlowDos: resultList,
      })
      if (data && data.code === 1) {
        message.success(data.message || "操作成功")
        yield put({
          type: "closeEdit"
        })
        yield put({
          type: "goPage",
          payload: {
            page: 1
          }
        })
      } else if (data && Error.get(data.code)) {
        message.warn(data.message)
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
